import { FProgressBar } from '../../../../../components/base';
import { ChildInfoFields, useFormReadOnly } from '../../../../common';
import { ChildBehaviorIssuesSection } from './components';
import { useFetchTreatmentPlanV3ChildPage, useTreatmentPlanV3Child } from './hooks';
import { TreatmentPlanV3PageContent, TreatmentPlanV3PageLoadState } from '../components';

export default function ClientInfoForm() {
  const { retry } = useFetchTreatmentPlanV3ChildPage();
  const {
    childBehaviorIssues,
    backgrounds,
    schedules,
    notAttendingSchool,
    isLoading,
    hasLoaded,
    hasLoadError,
    isSavingBackground,
    isSavingSchedule,
    isUpdatingBehaviorIssues,
    updateBehaviorIssues,
    createBackground,
    deleteBackground,
    createSchedule,
    deleteSchedule,
  } = useTreatmentPlanV3Child();
  const readOnly = useFormReadOnly();

  return (
    <TreatmentPlanV3PageContent title="Child background">
      <TreatmentPlanV3PageLoadState
        errorMessage="Unable to load child information. Please try again."
        hasLoaded={hasLoaded}
        hasLoadError={hasLoadError}
        onRetry={retry}
      >
        {isSavingBackground || isUpdatingBehaviorIssues ? <FProgressBar /> : null}
        <ChildInfoFields
          backgrounds={backgrounds}
          behaviorIssuesField={
            <ChildBehaviorIssuesSection
              childBehaviorIssues={childBehaviorIssues}
              disabled={isLoading || readOnly}
              onSave={updateBehaviorIssues}
            />
          }
          disabled={isLoading || isSavingBackground || readOnly}
          isSavingSchedule={isSavingSchedule}
          notAttendingSchool={notAttendingSchool}
          onAddSchedule={createSchedule}
          onCreateBackground={createBackground}
          onDeleteBackground={deleteBackground}
          onDeleteSchedule={deleteSchedule}
          scheduleDisabled={isLoading || isSavingSchedule}
          schedules={schedules}
          showListErrors
          showScheduleErrors
        />
      </TreatmentPlanV3PageLoadState>
    </TreatmentPlanV3PageContent>
  );
}
